//test

// global.baseUrl = "https://testemr-api-php.cb-dev.in"
// global.formUrl = "testemrforms.cb-dev.in "

//live

//  global.baseUrl = 'https://chapip.cbhcp.in'
//  global.formUrl = "forms.healthconnectpro.in"


//Lab live

 global.baseUrl = 'https://emr-api.healthconnectpro.in'
 global.formUrl = "forms.healthconnectpro.in"

//localhost
//global.baseUrl = 'http://localhost/emr-clinic-rest-api-php';

global.sendMailUrl = "https://cb-emr-api-nodejs.onrender.com";

export async function networkCall(method, endPoint, body) {
  try {
    const response = await fetch(global.baseUrl + endPoint, {
      method: method,
      body: JSON.stringify(body),
    });
    return response.json();
  } catch (e) {
    return { status: 0, message: "" + e };
  }
}